import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  TableCell,
  TableRow,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import { Edit, Delete, Link } from "@mui/icons-material";
import styles from "./CarouselListing.module.scss";
import CustomDialog from "../../../../library/common/CustomDialog";
import { api } from "../../../../services";
import { CONSTANTS } from "../../../../library/common/constant";
import { throttle } from "lodash";

const { DELETE_CONFIRM_TITLE, DELETE_CONFIRM_MESSAGE, THROTTLE_DURATION } =
  CONSTANTS;

const BannerItem = ({ bannerItem, getBannerList }) => {
  const navigate = useNavigate();
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleOpenDeleteDialogue = () => {
    setDialogOpen(true);
  };

  const handleCloseDeleteDialogue = () => {
    setDialogOpen(false);
  };

  const deleteBanner = throttle(async () => {
    try {
      setIsLoading(true);
      await api.delete(`/banners/${bannerItem?._id}`);
      await getBannerList();
      handleCloseDeleteDialogue();
    } catch (error) {
      console.error("Failed to delete: ", error);
    } finally {
      setIsLoading(false);
    }
  }, THROTTLE_DURATION);

  return (
    <>
      {bannerItem && (
        <TableRow hover className={styles.tableRow}>
          <TableCell>
            <Box className={styles.imageBox}>
              <img
                src={bannerItem?.imageUrl}
                alt={bannerItem?.altText}
                className={styles.image}
              />
            </Box>
          </TableCell>
          <TableCell>
            <Typography className={styles.textSecondary}>
              {bannerItem?.altText}
            </Typography>
          </TableCell>
          <TableCell>
            <div className={styles.urlContainer}>
              <Link fontSize="small" color="action" />
              <Typography className={styles.urlText}>
                {bannerItem?.redirectUrl}
              </Typography>
            </div>
          </TableCell>
          <TableCell>
            <div className={styles.actions}>
              <IconButton
                size="small"
                color="primary"
                className={styles.iconButton}
                onClick={() => {
                  navigate(`/banner/edit/${bannerItem?._id}`);
                }}
              >
                <Edit />
              </IconButton>
              <IconButton
                size="small"
                color="error"
                className={styles.iconButton}
                onClick={handleOpenDeleteDialogue}
              >
                <Delete />
              </IconButton>
            </div>
          </TableCell>
        </TableRow>
      )}

      <CustomDialog
        open={isDialogOpen}
        title={DELETE_CONFIRM_TITLE}
        content={DELETE_CONFIRM_MESSAGE}
        onClose={handleCloseDeleteDialogue}
        onSecondaryClick={handleCloseDeleteDialogue}
        onPrimaryClick={deleteBanner}
        disablePrimary={isLoading}
      />
    </>
  );
};

export default BannerItem;
